(() => {
  const source = 'https://elfsightcdn.com/platform.js';
  const widget = document.querySelector('.elfsight-app-7b4d1647-a3ed-403b-8246-d2dfec821060');
  if (!widget) return;

  let loaded = false;
  let observer;
  const loadWidgetScript = () => {
    if (loaded || document.querySelector('script[src="' + source + '"]')) return;
    loaded = true;
    if (observer) observer.disconnect();
    const script = document.createElement('script');
    script.src = source;
    script.async = true;
    document.head.appendChild(script);
  };

  // Do not trigger third-party JavaScript from unrelated menu, cart or search taps.
  widget.addEventListener('pointerdown', loadWidgetScript, { once: true, passive: true });
  widget.addEventListener('keydown', loadWidgetScript, { once: true });
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) loadWidgetScript();
    }, { rootMargin: '250px 0px' });
    observer.observe(widget);
  }
})();
